import API from '../context/API';

interface ApiResponse<T = any> {
  success?: boolean;
  status?: 'success' | number;
  data?: T;
  message?: string;
}

export const passwordResetAPI = {
  requestPasswordReset: async (email: string): Promise<ApiResponse> => {
    try {
      const response = await API.post<ApiResponse>('/merchant/forgot-password', { email });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  validateResetToken: async (token: string): Promise<ApiResponse> => {
    try {
      const response = await API.post<ApiResponse>('/merchant/validate-reset-token', { token });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  verifyResetOtp: async (email: string, otpCode: string): Promise<ApiResponse> => {
    try {
      const response = await API.post<ApiResponse>('/merchant/verify-reset-otp', {
        email,
        otpCode
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  resetPassword: async (email: string, password: string, confirmPassword?: string): Promise<ApiResponse> => {
    try {
      const payload: any = {
        email,
        password
      };

      if (confirmPassword) {
        payload.confirmPassword = confirmPassword;
      }

      const response = await API.post<ApiResponse>('/merchant/reset-password', payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};
